module.exports = __webpack_public_path__ + "img/add-cart.f54a2913.svg";